import React from 'react';
import Fire from "@/components/icons/FireIcon";
import ArrowIcon from "@/components/icons/ArrowIconFlat";
import PlayerAvatar from '@/components/common/PlayerAvatar';
import ToolTip from "@/components/common/ToolTip";
import { usePlayer } from '@/lib/usePlayer'

const PlayerLiveScore = ({ score, streak, avatar }) => {
    const { data: player } = usePlayer();
    const displayedName = player?.username.split(' \#') ? player?.username.split(' \#')[0] : player?.username
    return (
        <div className="m-1 p-1 bg-white/20 rounded-full flex justify-center font-gBold text-base">
            <ToolTip message={`${displayedName}`}>
                <div>
                    <PlayerAvatar avatar={avatar} />
                </div>
            </ToolTip>
            <ToolTip message={"Current Streak"}>
                <div className={'my-auto w-[4rem] text-center'}>
                    <Fire color="white" className="inline-block mr-1"/>
                    {streak || 0}
                </div>
            </ToolTip>
            <ToolTip message={"Today's Score"}>
                <div className={'my-auto pr-2 w-[4rem] text-center'}>
                    <ArrowIcon color="white" strokeColor={"white"} className="inline-block" />
                    <div className="inline-block w-5 text-left">{score || 0}</div>
                </div>
            </ToolTip>
        </div>
    )
}

export default PlayerLiveScore;